export default "__VITE_ASSET__CsfpvmZt__"